<template>
  <div id="photos_title_banner_component" class="text-white">
    <div class="d-flex justify-content-center align-items-start">
      <ButtonArrowCarouselPrevious dataBsTarget="#photos-home-carousel" dataBsSlide="prev" :numSlides="photos.length"/>
      <ButtonArrowCarouselNext dataBsTarget="#photos-home-carousel" dataBsSlide="next" :numSlides="photos.length"/>
    </div>
    <div id="photos-home-carousel" class="carousel slide" data-bs-ride="carousel">
      <div class="carousel-inner">
        <div
          v-for="(photosForPage, index) in photos"
          :key="index"
          :class="getClassCarouselItem(index)">
          <PhotoListHomePage :photos="photosForPage" />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue, prop } from "vue-class-component";

import PhotoListHomePage from "@/components/PhotoListHomePage.vue"

import ButtonArrowCarouselPrevious from "@/components/ButtonArrowCarouselPrevious.vue"
import ButtonArrowCarouselNext from "@/components/ButtonArrowCarouselNext.vue"

import { usePhotoStore } from "@/stores/photo";
import { useLanguageStore } from "@/stores/language";

// Define props in a class
class PhotoListHomeProps {
  photos = prop({
    // Same as Vue core's prop option
    type: Array,
    required: true,
    default: []
  })
  isLoading = prop({
    // Same as Vue core's prop option
    type: Boolean,
    required: true,
    default: []
  })
}

@Options({
  components: {
    PhotoListHomePage,
    ButtonArrowCarouselPrevious,
    ButtonArrowCarouselNext
  }
})
export default class PhotoListHome extends Vue.with(PhotoListHomeProps){
  photoStore = usePhotoStore()
  languageStore = useLanguageStore()

  public getClassCarouselItem(page: number) {
    return page === 0 ? 'carousel-item active' : 'carousel-item'
  }
}
</script>

<style lang="stylus">
#photos-content-row {
  margin-left: auto
  margin-right: auto
}

</style>